module.exports = __webpack_public_path__ + "static/img/2bg_4.322e410.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_4.png
// module id = 673
// module chunks = 1